import * as React from 'react';
import { compose } from 'recompose';
import { reduxForm } from 'redux-form';
import { get } from 'lodash';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Divider from 'material-ui/Divider';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Date, DateField, RemoteAutoComplete, RemoteAutoCompleteField, Input, InputField } from '@components/form';

import * as T from '@modules/employees/_employeesTypes';

export const enhance = compose<T.EmplyeesFormProps, T.Outter>(
  reduxForm({
    form: 'module-employee-contracts',
    initialValues: { certificates: [] }
  })
);

export const View: React.SFC<T.Outter & T.EmplyeesFormProps> = ({ handleSubmit, closeItem }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>

        <Row>
          <Col md={12}>
            <Row>
              <Col md={4}>
                <h4>Datum absolvování</h4>
              </Col>
              <Col md={8}>
                <DateField component={Date} id="absolved" name="absolved" />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Datum platnosti</h4>
              </Col>
              <Col md={8}>
                <DateField component={Date} id="validTo" name="validTo" allowFuture={true} />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Typ</h4>
              </Col>
              <Col md={8}>
                <RemoteAutoCompleteField
                  id="type"
                  name="type"
                  component={RemoteAutoComplete}
                  url="/metropolis/api/hr/certificateTypes"
                  filterActive={true}
                  labelFunction={o => get(o, 'name')}
                  arrowstyle={{
                    color: '#e1e0e1',
                    position: 'absolute',
                    right: 0,
                    top: 16
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={4}>
                <h4>Poznámka</h4>
              </Col>
              <Col md={8}>
                <InputField
                  component={Input}
                  multiLine={true}
                  id="note"
                  name="note"
                  style={{ maxHeight: '60vh' }}
                  inputStyle={{ maxHeight: '60vh' }}
                  textareaStyle={{ maxHeight: '56vh' }}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      <Divider />

      <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  </div>
);

export const EmployeesFormCertificatesForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesFormCertificatesForm.tsx